import { createFileRoute, redirect } from "@tanstack/react-router";

// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders
export const Route = createFileRoute("/(private)/library/")({
  beforeLoad: () => {
    throw redirect({ to: "/library/workouts" });
  },
});
